
export const msalConfig = {
    auth: {
        clientId: "28bcb2c8-2ed9-4374-ad01-a48c53fbdf04",
        tenantId: "651a27dd-3f74-48e8-90aa-f2239e406737",
        authority: "https://login.microsoftonline.com/651a27dd-3f74-48e8-90aa-f2239e406737",
        redirectUri: "/"
    }
}

export const loginRequest = {
    scopes: ["api://28bcb2c8-2ed9-4374-ad01-a48c53fbdf04/Decisions.Read"]
};